import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { backToDashboard } from "../srs-applications/actions";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import style from "./style.module.scss";
import { useEffect } from "react";
import { AppURL } from "utils/Actions";

const NotFound = () => {
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname === AppURL.school.easApplications) {
      backToDashboard(history);
    }
  }, [history.location.pathname, backToDashboard]);

  return (
    <>
      <Helmet>
        <title>{t("helmet.notFound.title")}</title>
        <meta name="description" content={t("helmet.notFound.meta") || ""} />
      </Helmet>
      <div className={style.container}>
        <div style={{ width: "40rem" }}>
          <h1 className="text-center">{t("notFound.title")}</h1>
          <p className="text-center">{t("notFound.desc")}</p>
          <br />
          <div className="center-justify">
            <Button type="primary" onClick={() => backToDashboard(history)}>
              {t("notFound.backBtn")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
